import { BsPersonWorkspace } from "react-icons/bs";
import { BiCameraMovie, BiSolidFactory } from "react-icons/bi";
import { AiOutlineCloudServer } from "react-icons/ai";
import { GoTasklist } from "react-icons/go";
import { RxLapTimer } from "react-icons/rx";
import { TbPasswordMobilePhone } from "react-icons/tb";
import { IoBookmarks } from "react-icons/io5";
import React from "react";

let resumeData = {
  imagebaseurl: "https://rbhatia46.github.io/",
  name: "Sujal Gandhi",
  role: "Software Developer and Web Developer",
  linkedinId: "Your LinkedIn Id",
  skypeid: "Your skypeid",
  roleDescription:
    "I like dabbling in various parts of frontend development and like to learn about new technologies, write technical articles or simply play games in my free time.",
  socialLinks: [
    {
      id: 1,
      name: "linkedin",
      url: "https://www.linkedin.com/in/sujalgandhi/",
      className: "fa fa-linkedin",
    },
    {
      id: 2,
      name: "github",
      url: "http://github.com/Sujal366",
      className: "fa fa-github",
    },
    {
      id: 3,
      name: "instagram",
      url: "http://instagram.com/sujalgandhi63",
      className: "fa fa-instagram",
    },
  ],
  aboutme:
    "I am currently a final year student at TSEC and pursuing my B.Tech in Information Technology from here. I am a Web Dev Enthusiast, currently diving deeper into AI Agents.",
  address: "India",
  website: "sujalgandhi786@gmail.com",
  education: [
    {
      UniversityName: "Thadomal Shahani Engineering College",
      specialization: "Information Technology",
      MonthOfPassing: "May",
      YearOfPassing: "2025",
      Achievements: "",
    },
    {
      UniversityName: "Some University",
      specialization: "Some specialization",
      MonthOfPassing: "Jan",
      YearOfPassing: "2018",
      Achievements: "Some Achievements",
    },
  ],
  work: [
    {
      index: 1,
      CompanyName: "Franchise Discovery",
      specialization: "Frontend Developer Intern",
      MonthOfLeaving: "June 2024 - ",
      YearOfLeaving: "August 2024",
      Achievements: [
        {
          id: 1,
          description:
            "Developed an interactive website using React.js and Next.js, attracting 1,000 new users within the first month.",
        },
        {
          id: 2,
          description:
            "Developed interactive dashboards and data visualization components using React.js to enhance user insights.",
        },
        {
          id: 3,
          description:
            "Engineered efficient state management and seamless component interaction with Custom Hooks and Context API; accelerated development speed by 30% and reduced bug incidence by 20%",
        },
        {
          id: 4,
          description:
            "Implemented Tailwind CSS to design a responsive UI, cutting development time by making 1 page per day.",
        },
      ],
    },
    {
      index: 2,
      CompanyName: "Mantra Softech",
      specialization: "Java Developer Intern",
      MonthOfLeaving: "December 2023 – ",
      YearOfLeaving: "January 2024",
      Achievements: [
        {
          id: 1,
          description:
            "Developed a Java based command-line banking application. The system supports the creation of multiple user accounts across various banks.",
        },
        {
          id: 2,
          description:
            "There are two types of accounts: Bank Administrator and Bank Client.",
        },
        {
          id: 3,
          description:
            "Users can perform transactions such as deposits, withdrawals, balance inquiries, and fund transfers between accounts.",
        },
        {
          id: 4,
          description:
            "Worked with SQL databases, writing optimized queries for data retrieval and reporting.",
        },
      ],
    },
    {
      index: 3,
      CompanyName: "Prime Software Solution",
      specialization: "Junior Software Developer",
      MonthOfLeaving: "June 2023 – ",
      YearOfLeaving: "July 2023",
      Achievements: [
        {
          id: 1,
          description:
            "Created responsive and interactive website pages tailored to client requirements, utilizing HTML, CSS, and JavaScript to ensure seamless user experiences across devices.",
        },
        {
          id: 2,
          description:
            "Utilized Git and GitHub for effective version control and collaborative development, enabling seamless code management and team collaboration.",
        },
      ],
    },
  ],
  skillsDescription: "Your skills here",
  skills: [
    {
      skillname: "HTML5",
    },
    {
      skillname: "CSS",
    },
    {
      skillname: "Reactjs",
    },
  ],
  portfolio: [
    {
      id: 1,
      logo: <AiOutlineCloudServer />,
      name: "Homelab Server",
      description:
        "Set up a personal homelab server for hosting applications and services like NAS for cloud storage, VPN (Twingate) for secure remote connectivity, Glances for monitoring system performance, Vaultwarden for password management, CasaOS for server management along with Files for file organization and various other self-hosted projects.",
      // link: "https://github.com/Sujal366/",
    },
    {
      id: 2,
      logo: <GoTasklist />,
      name: "Kanban Board",
      description:
        "A full-stack task management application allowing users to create, edit, update, and delete tasks., using drag-and-drop feature for seamless task movement across statuses, with a responsive React and Tailwind UI using MongoDB for efficient data management",
      link: "https://github.com/Sujal366/kanban-board",
    },
    {
      id: 3,
      name: "Career Wise",
      logo: <BsPersonWorkspace />,
      description:
        "Utilizing an algorithm, personalized career advice is provided based on skills and interests. Using a custom algorithm to align test scores with ideal career choices, promoting informed decisions. Boosting user confidence with a real-time chatbot for career queries, enhancing understanding.",
      link: "https://career.dembi.xyz/",
    },
    {
      id: 4,
      logo: <BiSolidFactory />,
      name: "Equipment Maintenance Tracker",
      description:
        "A web app designed to help factory managers track, schedule and manage the maintenance of their equipments. It allows users to log maintenance activities and generate reports on equipment status. Test credentials - 1. Manager id: sujal@gmail.com, password: password123 2. Technician id: tech1@gmail.com, password: password123",
      link: "https://equipment-maintenance-tracker.sujalgandhi.me",
    },
    {
      id: 5,
      logo: <IoBookmarks />,
      name: "Bookmark App",
      description:
        "A React + Vite app to manage bookmarks efficiently. Users can add, edit, delete, search, and organize bookmarks by categories. It saves data in local storage, supports fuzzy search by tags, titles, or notes, and allows switching between views (Active, Read-later, Archived). It also supports exporting links and notes (e.g., JSON, CSV).",
      link: "https://bookmark.sujalgandhi.me",
    },
    {
      id: 6,
      logo: <RxLapTimer />,
      name: "Stopwatch",
      description:
        "Stopwatch is a simple web application that allows users to track time intervals. It features start, stop, and reset functionalities, providing an intuitive interface for time management.",
      link: "https://stopwatch.sujalgandhi.me/",
    },
    {
      id: 7,
      logo: <TbPasswordMobilePhone />,
      name: "Password Generator",
      description:
        "A simple password generator that creates strong, random passwords to enhance security. Users can customize password length and complexity, ensuring robust protection for their accounts.",
      link: "https://password-generator.sujalgandhi.me/",
    },
    {
      id: 8,
      logo: <BiCameraMovie />,
      name: "Movie Ticket Booking System",
      description:
        "A simple cinema booking system implemented in Python using Tkinter for the graphical user interface (GUI) and MySQL for the database. Users can register, login, select movies, book seats, and make payments through this system.",
      link: "https://github.com/Sujal366/Movie-Ticket-Booking-System",
    },
  ],
  testimonials: [
    {
      description: "This is a sample testimonial",
      name: "Some technical guy",
    },
    {
      description: "This is a sample testimonial",
      name: "Some technical guy",
    },
  ],
};

export default resumeData;
